import React from 'react';
import { ModuleId } from '../../types';
import { getHintsForSubSkill, getAllHintsForModule, SubSkillHint } from '../../data/hints';
import { VisualAidFactory } from '../visuals/VisualAidFactory';
import { LatexRenderer } from '../ui/LatexRenderer';
import { AlertCircle } from 'lucide-react';
interface SubSkillCheatSheetProps {
  moduleId: ModuleId;
  subSkill?: string;
}
export function SubSkillCheatSheet({
  moduleId,
  subSkill
}: SubSkillCheatSheetProps) {
  const specificHint = subSkill ? getHintsForSubSkill(moduleId, subSkill) : null;
  const allHints = !specificHint ? getAllHintsForModule(moduleId) : [];
  if (!specificHint && allHints.length === 0) {
    return <div className="text-center p-8 bg-slate-50 rounded-xl border border-slate-100" data-id="element-1525">
        <AlertCircle className="w-10 h-10 mx-auto mb-3 text-slate-300" data-id="element-1526" />
        <p className="text-slate-500 font-medium" data-id="element-1527">
          Geen spiekbriefje beschikbaar voor dit onderwerp.
        </p>
      </div>;
  }
  const renderHintSection = (hint: SubSkillHint) => <div key={hint.id} className="mb-8 last:mb-0 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-1528">
      <div className="mb-4 border-b border-slate-100 pb-2" data-id="element-1529">
        <h3 className="text-xl font-bold text-slate-900" data-id="element-1530">{hint.title}</h3>
        {hint.description && <p className="text-slate-600 text-sm mt-1" data-id="element-1531">{hint.description}</p>}
      </div>

      <div className="space-y-4" data-id="element-1532">
        {hint.steps.map((step, index) => <div key={index} className="group" data-id="element-1533">
            <div className="bg-white rounded-xl p-4 border border-slate-200 shadow-sm hover:border-indigo-200 transition-colors" data-id="element-1534">
              <div className="flex gap-3" data-id="element-1535">
                {/* Compact Step Indicator */}
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-indigo-50 text-indigo-600 flex items-center justify-center text-xs font-bold mt-0.5" data-id="element-1536">
                  {index + 1}
                </div>

                <div className="flex-1" data-id="element-1537">
                  {step.title && <h4 className="font-bold text-slate-800 mb-1 text-base" data-id="element-1538">
                      {step.title}
                    </h4>}

                  <div className="text-slate-700 text-sm leading-relaxed whitespace-pre-line" data-id="element-1539">
                    <LatexRenderer content={step.content} data-id="element-1540" />
                  </div>

                  {step.visual && <div className="mt-4 bg-slate-50 rounded-lg p-3 border border-slate-100" data-id="element-1541">
                      <VisualAidFactory visualAid={{
                  type: step.visual.type,
                  data: step.visual.data,
                  showWhen: 'always'
                }} data-id="element-1542" />
                    </div>}
                </div>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
  return <div className="space-y-6" data-id="element-1543">
      {specificHint ? renderHintSection(specificHint) : <div className="space-y-8" data-id="element-1544">
          <div className="bg-indigo-50 p-4 rounded-xl border border-indigo-100 mb-6 text-center" data-id="element-1545">
            <p className="text-indigo-900 font-medium text-sm" data-id="element-1546">
              Alle hulpmiddelen voor{' '}
              <span className="font-bold" data-id="element-1547">{moduleId}</span>
            </p>
          </div>
          {allHints.map(hint => renderHintSection(hint))}
        </div>}
    </div>;
}